import { ConfigProvider } from 'antd';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import { StoreProvider } from './store';
import ja_JP from 'antd/lib/locale-provider/ja_JP';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 1000,
      cacheTime: 1000,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <StoreProvider>
      <ConfigProvider locale={ja_JP}>
        <QueryClientProvider client={queryClient}>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
          <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
        </QueryClientProvider>
      </ConfigProvider>
    </StoreProvider>
  </React.StrictMode>
);

reportWebVitals();
